function Analytics() {
  // PUBLIC FUNCTIONS
  function pushDataLayerAddToCart(element) {
    const product = element.closest("[data-js-product-add-to-cart]");
    const quantitySelector = document.querySelector("product-quantity [name=quantity]");

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: "add_to_cart",
      collection_type: product.dataset.type,
      ecommerce: {
        currency: "EUR",
        value: parseFloat(product.price) / 100,
        items: [
          {
            item_id: product.dataset.id,
            item_name: product.dataset.title,
            item_category: product.dataset.type,
            price: parseFloat(product.dataset.price) / 100,
            quantity: quantitySelector ? quantitySelector.value : 1,
          },
        ],
      },
    });
  }

  function pushDataLayerBeginCheckout() {
    const cartTotal = document.querySelector(".cart__total [data-total]");

    const items = [];
    const products = document.querySelectorAll(".cart-form-item");

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const price = product.querySelector("[data-price]");

      items.push({
        item_id: product.dataset.productId,
        item_name: product.dataset.title,
        item_category: product.dataset.type,
        price: parseFloat(price.dataset.price) / 100,
        quantity: product.dataset.qty,
      });
    }

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: "begin_checkout",
      ecommerce: {
        currency: "EUR",
        value: parseFloat(cartTotal.dataset.total) / 100,
        items,
      },
    });
  }

  function pushDataLayerGeneric(customer) {
    const pageType = getPageType(location.pathname);

    dataLayer.push({
      event: "dl_start",
      page_type: pageType,
      page_language: getLanguage(),
      login_status: customer ? "logged" : "not logged",
    });
  }

  function pushDataHomePageBanner(url) {
    dataLayer.push({
      event: 'hp_banner_click',
      url_button_destination: url,
    });
  }

  function pushDataLayerIscrizioneCommunity(id) {
    const email = document.getElementById(`Email-${id}`).value;

    dataLayer.push({
      event: "iscrizione_community_clai",
      user_email_md5: CryptoJS.MD5(email).toString(),
      user_email_sha256: CryptoJS.SHA256(email).toString(),
    });
  }

  function pushDataLayerPDP(product) {
    if (product) {
      dataLayer.push({ ecommerce: null });

      dataLayer.push({
        event: "view_item",
        collection_type: product.type,
        ecommerce: {
          currency: "EUR",
          value: parseFloat(product.price) / 100,
          items: [
            {
              item_id: product.id,
              item_name: product.title,
              item_category: product.type,
              price: parseFloat(product.price) / 100,
              quantity: null, // TODO
            },
          ],
        },
      });
    }
  }

  function pushDataLayerRegistration(result) {
    if (result) {
      dataLayer.push({
        event: "new_registration",
        new_registration_result: result,
        user_email_md5: CryptoJS.MD5(customer.email).toString(),
        user_email_sha256: CryptoJS.SHA256(customer.email).toString(),
      });
    } else if (location.pathname.includes("account-registered")) {
      dataLayer.push({
        event: "new_registration",
        new_registration_result: "registered",
        user_email_md5: CryptoJS.MD5(customer.email).toString(),
        user_email_sha256: CryptoJS.SHA256(customer.email).toString(),
      });
    }
  }

  function pushDataLayerRemoveFromCart(product) {
    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: "remove_from_cart",
      collection_type: product.dataset.type,
      ecommerce: {
        currency: "EUR",
        value: parseFloat(product.price) / 100,
        items: [
          {
            item_id: product.dataset.id,
            item_name: product.dataset.title,
            item_category: product.dataset.type,
            price: parseFloat(product.dataset.price) / 100,
            quantity: null, // TODO
          },
        ],
      },
    });
  }

  function pushDataLayerSearchComplete(terms, results) {
    window.dataLayer.push({
      event: "search_complete",
      search_term: terms,
      search_result: results > 0 ? "OK" : "KO",
    });
  }

  function pushDataLayerSocial(position, social) {
    dataLayer.push({
      event: 'link_out_social',
      link_out_position: position,
      social,
    });
  }

  function pushDataLayerViewCart(cart) {
    const items = [];
    cart.items.forEach((item) => {
      items.push({
        item_id: item.id,
        item_name: item.title,
        item_category: item.product_type,
        price: parseFloat(item.price) / 100,
        quantity: item.quantity,
      });
    });

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: "EUR",
        value: parseFloat(cart.total_price) / 100,
        items,
      },
    });
  }

  // PRIVATE FUNCTIONS
  function pushDataLayerFormContattaci() {
    if (!window.location.pathname.includes("modulo-inviato")) {
      return;
    }

    dataLayer.push({
      event: "form_contattaci",
      contact_form_object: null, // TODO
      user_email_sha256: null, // TODO
      user_email_md5: null, // TODO
    });
  }

  function pushDataLayerLogin() {
    const element = document.querySelector("#customer_login");

    if (!element) {
      return;
    }

    element.addEventListener("submit", () => {
      const email = element.querySelector("#customer_email").value;

      dataLayer.push({
        event: "login",
        user_email_md5: CryptoJS.MD5(email).toString(),
        user_email_sha256: CryptoJS.SHA256(email).toString(),
      });
    });
  }

  function pushDataLayerPLP() {
    const pathname = location.pathname;
    const pageType = getPageType(pathname);

    if (pageType === "product_list") {
      const pathSegments = pathname.split("/").filter((segment) => segment !== "en").filter((segment) => segment.trim() !== "");
      const products = document.getElementById("main-collection-product-grid").children;

      const items = [];
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        items.push({
          item_id: product.dataset.id,
          item_name: product.dataset.title,
          item_category: product.dataset.type,
          price: parseFloat(product.dataset.price) / 100,
          quantity: null, // TODO
        });
      }

      dataLayer.push({ ecommerce: null });

      dataLayer.push({
        event: "view_item_list",
        collection_type: pathSegments[1],
        ecommerce: {
          items,
        },
      });
    }
  }

  // UTILS FUNCTIONS
  function getLanguage() {
    const pathname = location.pathname.split("/");

    switch (pathname[1]) {
      case "en":
        return "en";
      default:
        return "it";
    }
  }

  function getPageType(pathname) {
    const pathSegments = pathname
      .split("/")
      .filter((segment) => segment !== "en")
      .filter((segment) => segment.trim() !== "");

    if (pathSegments.length === 0 || pathname === "/") {
      return "home";
    } else if (pathSegments[0] === "collections") {
      if (pathSegments[2] === "products") {
        return "product";
      } else {
        return "product_list";
      }
    } else if (pathSegments[0] === "search") {
      return "search_page";
    } else if (pathSegments[0] === "account") {
      return "account";
    } else if (pathSegments[0] === "cart") {
      return "cart";
    } else if (pathSegments[0] === "challenge") {
      return "challenge";
    } else if (pathSegments[0] === "pages") {
      return "pages";
    } else if (pathSegments[0] === "checkout") {
      return "checkout";
    } else if (pathSegments.length > 2) {
      return pathSegments[1];
    } else {
      return "404";
    }
  }

  async function init() {
    await document.addEventListener("DOMContentLoaded", async function () {
      pushDataLayerFormContattaci();
      pushDataLayerLogin();
      pushDataLayerPLP();
      pushDataLayerRegistration();
    });
  }

  init();

  return {
    pushDataLayerAddToCart: pushDataLayerAddToCart,
    pushDataLayerBeginCheckout: pushDataLayerBeginCheckout,
    pushDataLayerGeneric: pushDataLayerGeneric,
    pushDataHomePageBanner: pushDataHomePageBanner,
    pushDataLayerIscrizioneCommunity: pushDataLayerIscrizioneCommunity,
    pushDataLayerPDP: pushDataLayerPDP,
    pushDataLayerRegistration: pushDataLayerRegistration,
    pushDataLayerRemoveFromCart: pushDataLayerRemoveFromCart,
    pushDataLayerSearchComplete: pushDataLayerSearchComplete,
    pushDataLayerSocial: pushDataLayerSocial,
    pushDataLayerViewCart: pushDataLayerViewCart,
  };
}
